    // FAQ
    function toggleFaq(q) {
      const a = q.nextElementSibling;
      const ic = q.querySelector('.ic');
      const open = a.classList.contains('open');
      q.closest('.faq-list').querySelectorAll('.faq-a.open').forEach(x => {
        x.classList.remove('open');
        x.previousElementSibling.querySelector('.ic').classList.remove('open');
      });
      if (!open) { a.classList.add('open'); ic.classList.add('open'); }
    }
    const firstFaq = document.querySelector('.faq-q');
    if (firstFaq) {
      firstFaq.click();
    }

    // Form submit (demo)
    function submitForm(e) {
      e.preventDefault();
      const btn = e.target.querySelector('.form-submit');
      const original = btn.innerHTML;
      btn.innerHTML = '✓ Brief received';
      btn.style.background = '#5C8A6E';
      setTimeout(() => {
        e.target.reset();
        btn.innerHTML = original;
        btn.style.background = '';
      }, 2400);
    }

    // Reveal
    const ro = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); ro.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.reveal').forEach(el => ro.observe(el));

    // Handle Shopify Theme Customizer section loads
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('.reveal').forEach(el => ro.observe(el));
      
      // Auto-open first FAQ if it's the FAQ section being loaded
      const firstFaq = event.target.querySelector('.faq-q');
      if (firstFaq && !firstFaq.nextElementSibling.classList.contains('open')) {
        firstFaq.click();
      }
    });
